import http from "./http_common";

class PaymentService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }
  PhonepeTransaction(data) {
    return http.post(`phonepeTransaction/`, data);
  }
  BillingTransaction(data) {
    return http.post(`billingTransaction/`, data);
  }
  getTransactionStatus(payload) {
    var queryString = this.queryString(payload);
    return http.get(`phonePeResponse1/paymentRedirectDetails?${queryString}`);
  }
  getBillingTransaction(payload) {
    var queryString = this.queryString(payload);
    // return http.get(`billingTransaction/list/filter?${queryString}`);
    return http.get(`/billingTransactionServices/list/filter?${queryString}`);
  }

  getBillingCount(payload) {
    var queryString = this.queryString(payload);
    // return http.get(
    //   `/billingTransaction/getBillingTransactionCountStatus?${queryString}`
    // );
    return http.get(`/billingTransactionServices/getBillingTransactionServicesCountStatus?${queryString}`);
  }

  refundRequestsList(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/refundRequest/list/filter?${queryString}`);
  }

  refundApproveReject(data) {
    return http.put('/refundRequest/update/approved-reject-reason', data);
  }

  medcineOrdRefApprReject(payload) {
    return http.put('/refundRequest/update/pharmacy-approved-reject-reason', payload);
  }

  labOrdRefApprReject(payload) {
    return http.put('/refundRequest/update/lab-approved-reject-reason', payload);
  }

  GetAppointmentId(payload) {
    const queryString = this.queryString(payload);
    return http.get(`invitationDetails/list/filter?${queryString}`);
  }

  // Old payment api
  // initiatePayment(payload) {
  //   return http.post('/phonePeResponse1/phonepe/payment-initiate', payload);
  // }
   initiatePayment(payload) {
    return http.post('/phonePeResponse1/createPayment', payload);
  }

  CartUpdate(id, data) {
    return http.put(`/CartDetails/update-status/${id}`, data);
  }

  walletList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/Wallet/list/filter?${queryString}`);
  }

  userCurrentWalletTotal(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/Wallet/getWallet?${queryString}`);
  }

  walletTransaction(payload) {
    return http.post('/Wallet/', payload);
  }

  walletTransactionHistory(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/WalletTransaction/list/filter?${queryString}`);
  }
}
export default new PaymentService();
